module.exports = __webpack_public_path__ + "static/media/x-circle-light.4be50b05.svg";